import React from "react";
import { Field } from "formik";
import CasinoIcon from "@mui/icons-material/Casino";
import { IconButton, InputAdornment } from "@mui/material";

import { FormInput } from "../../../../../components/ui";
import { generateRandomString } from "../../../../../utils/generateRandomString";

interface IProps {
  password: string;
  setFieldValue: (path: string, values: string) => void;
}

const PasswordInput: React.FC<IProps> = ({ password, setFieldValue }) =>
  password ? (
    <Field
      name="password"
      component={FormInput}
      label="Password"
      disabled
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={(): void => {
                setFieldValue("password", generateRandomString(8));
              }}
              onMouseDown={(event): void => event.preventDefault()}
            >
              <CasinoIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  ) : null;

export default PasswordInput;
